import { useUserStore } from '@/store';

export function logout() {
  clearAllTokens();
  // 重新加载页面以确保所有状态被完全重置
  window.location.reload();
}

export function clearAllTokens() {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  // 清空所有持久化的 store 数据，防止用户数据泄露
  localStorage.removeItem('userStore');
  localStorage.removeItem('aiStore');
  localStorage.removeItem('configStore');
  localStorage.removeItem('distributionStore');
  sessionStorage.removeItem('probfun_dynamic_course_context');
  sessionStorage.removeItem('probfun_dynamic_course_return_to');
  sessionStorage.removeItem('probfun_local_teacher_preview');
  sessionStorage.removeItem('probfun_local_admin_preview');
  sessionStorage.removeItem('probfun_local_student_preview');
  sessionStorage.removeItem('setup_phone');
}

export function setLocalToken(token: string) {
  localStorage.setItem('token', token);
}

export function setRefreshToken(token: string) {
  localStorage.setItem('refreshToken', token);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem('refreshToken');
}

export function isVisitor() {
  return useUserStore().user?.role === -1;
}

export function isPlatformAdminUser(user = useUserStore().user) {
  return Boolean(
    user
    && (
      user.isPlatformAdmin
      || user.isSuperuser
      || Number(user.role) === 9
    ),
  );
}

export function isAnnouncementManagerUser(user = useUserStore().user) {
  return Boolean(user && (Number(user.role) === 2 || isPlatformAdminUser(user)));
}

export function getAuthToken() {
  return `Bearer ${localStorage.getItem('token')}`;
}
